import { GeneralContractor } from '@api/api';
import { AccountInfo } from '@azure/msal-browser';
import { BaseState, LoadingState } from '@core/utility/state';

export const identityStateKey = 'identity';

export interface IdentityState extends BaseState {
  account: AccountInfo | null;
  generalContractor: GeneralContractor | null;
}

export const initialIdentityState: IdentityState = {
  account: null,
  generalContractor: null,
  requestState: LoadingState.INIT,
};
